import { get } from './methods';

export default {
  relatorioVotos: (idAssembleia: number) => {
    const endpoint = `relatorio/relatorio-analitico/${idAssembleia}`;
    return get<ArrayBuffer>(endpoint, { responseType: 'arraybuffer' });
  },
  relatorioFinal: (idAssembleia: number) => {
    const endpoint = `relatorio/relatorio-sintetico/${idAssembleia}`;
    return get<ArrayBuffer>(endpoint, { responseType: 'arraybuffer' });
  },
}
